import React, { useEffect } from 'react';
// Componentes
import { CaptchaPlaceholder } from '../../../pages/AboutEvent/rsvp/inputs/Captcha';

export default function Captcha({ deleteComponent, rowId, colId, setAttributes }) {
  useEffect(() => {
    setAttributes({
      rowId,
      colId,
      attributes: {
        inputName: 'Captcha',
        required: true,
        uniqueField: 'Captcha',
      },
    });
  }, [rowId, colId, setAttributes]);

  return (
    <div>
      <div className="displayed-config-container">
        <div className="displayed-label">
          <CaptchaPlaceholder />
        </div>
        <div className="config-form-icon">
          <span
            className="mdi mdi-close close-icon"
            title="Remover Campo"
            onClick={() => deleteComponent(rowId, colId)}
          />
        </div>
      </div>
    </div>
  );
}
